import { FormTextArea } from 'components/shared/Forms/ReduxForm'
import SortableCell from 'components/shared/Helpers/SortableCell'
import SortableHeaderCell from 'components/shared/Helpers/SortableHeaderCell'
import config from 'config/config'

import { I18n } from 'lib/i18n'
import React from 'react'
import Highlighter from 'react-highlight-words'
import { Field, formValues } from 'redux-form'
import { Icon, List, Table } from 'semantic-ui-react'

class PropertyValuesList extends React.Component {
  state = {
    sortCol: 'value_de',
    direction: 'ascending',
  }

  sortBy(sortCol) {
    const { direction } = this.state

    this.setState({
      sortCol: sortCol,
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  getHighlightedListItems(list, highlight) {
    return list.map((propertyValueItem, index) => (
      <List.Item key={index}>
        <Highlighter
          highlightClassName="highlight"
          searchWords={[highlight]}
          textToHighlight={propertyValueItem}
          aciveIndex={-1}
        />
      </List.Item>
    ))
  }

  getPropertyValueList() {
    // state for sorting
    const { sortCol, direction } = this.state
    const {
      selectedProperty: { property_values: propertyValues = [] },
      filterText = '',
      editingValueId,
    } = this.props
    const {
      setEditingValueId,
      handleSubmit,
      handleCancel,
      handleDelete,
    } = this.props

    let sortedPropertyValues = propertyValues.filter(
      (propertyValue) =>
        propertyValue.value_de
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        propertyValue.value_fr.toLowerCase().includes(filterText.toLowerCase())
    )
    if (sortCol)
      sortedPropertyValues = sortedPropertyValues.sort(
        (a, b) =>
          typeof a[sortCol] === 'number'
            ? a[sortCol] - b[sortCol]
            : a[sortCol].localeCompare(b[sortCol])
      )
    if (sortCol && direction !== 'ascending')
      sortedPropertyValues = sortedPropertyValues.reverse()

    return sortedPropertyValues.map((propertyValue) => {
      if (editingValueId === propertyValue.id) {
        return (
          <Table.Row className="editable" key={propertyValue.id}>
            <Table.Cell>
              <Field component={FormTextArea} name="valueDe" />
            </Table.Cell>
            <Table.Cell>
              <Field component={FormTextArea} name="valueFr" />
            </Table.Cell>
            <Table.Cell textAlign="right">
              <Icon onClick={handleCancel} {...config.icons.cancel} link />
              <Icon onClick={handleSubmit} {...config.icons.save} link />
              <Icon
                onClick={() => handleDelete(propertyValue.id)}
                {...config.icons.delete}
                link
              />
            </Table.Cell>
          </Table.Row>
        )
      } else {
        const list_de =
          (propertyValue.value_de && propertyValue.value_de.split('\n')) || []
        const list_fr =
          (propertyValue.value_fr && propertyValue.value_fr.split('\n')) || []
        return (
          <Table.Row
            key={propertyValue.id}
            style={{ cursor: 'default' }}
            onClick={(event) => {
              event.preventDefault()
              setEditingValueId(propertyValue.id)
            }}>
            <SortableCell sort={sortCol} name="value_de">
              <List
                bulleted={list_de && list_de.length > 1}
                children={this.getHighlightedListItems(list_de, filterText)}
              />
            </SortableCell>
            <SortableCell
              sort={sortCol}
              name="value_fr"
              highlight={filterText}
              className="unobtrusive">
              <List
                bulleted={list_fr && list_fr.length > 1}
                children={this.getHighlightedListItems(list_fr, filterText)}
              />
            </SortableCell>
            {/*
                          Not implemented in Backend.

            <Table.Cell textAlign='right'>
*/}
            {/*
              <Icon
                onClick={() => handleDelete(propertyValue.id)}
                {...config.icons.delete}
                link
              />
            </Table.Cell>
*/}
          </Table.Row>
        )
      }
    })
  }

  render() {
    const { selectedProperty } = this.props
    const { sortCol, direction } = this.state
    if (!selectedProperty) return false
    return (
      <Table
        sortable
        compact
        size="small"
        selectable
        basic="very"
        className="spaced">
        <Table.Header>
          <Table.Row>
            <SortableHeaderCell
              width={6}
              name="value_de"
              onClick={() => this.sortBy('value_de')}
              title={I18n.t('navigation.languages.de')}
              sortCol={sortCol}
              direction={direction}
            />
            <SortableHeaderCell
              width={6}
              name="value_fr"
              onClick={() => this.sortBy('value_fr')}
              title={I18n.t('navigation.languages.fr')}
              sortCol={sortCol}
              direction={direction}
              className="unobtrusive"
            />
            {/*<Table.HeaderCell collapsing className='no-sort'/>*/}
          </Table.Row>
        </Table.Header>
        <Table.Body children={this.getPropertyValueList()} />
      </Table>
    )
  }
}

PropertyValuesList = formValues('filterText', 'editingValueId')(
  PropertyValuesList
)
export default PropertyValuesList



// WEBPACK FOOTER //
// ./src/components/admin/Properties/PropertyValuesList.jsx